module.exports = __webpack_public_path__ + "static/CompassShot-229d3181993f23c46e66c56cb80e3252.png";